var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diy-avatar"},[_c('figure',{staticClass:"diy-avatar__wrapper",class:_vm.size},[_c('img',{staticClass:"diy-avatar__image",attrs:{"src":_vm.src,"alt":_vm.alt}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }